import api from "../api";
import SearchRouteResult from "../models/SearchRouteResult";
import {extractNodesFromSearchParams, extractOptionsFromSearchParams} from "./routeService";
import axios from "axios";
import SearchRouteError from "../models/SearchRouteError";

/**
 * Поиск маршрута по заданным параметрам поиска.
 * Маршрут будет включать дополнительные точки по дорогам внутри городов.
 * @param {SearchRouteParameters} searchParameters Объект с параметрами поиска
 * @returns {SearchRouteResult}
 */
export const getRouteInfo = async searchParameters => {
  const request = {
    options: extractOptionsFromSearchParams(searchParameters),
    nodes: extractNodesFromSearchParams(searchParameters),
    excludeCities: searchParameters.excludedCities.map(city => city.id),
    excludeRegions: [],
    excludeCountries: searchParameters.excludedCountries.map(country => country.id)
  }
  try {
    /** @type {RouteResponse} */
    const routeResponse = await api.distancer.getRouteInfo(request, searchParameters.routeRequest);
    return new SearchRouteResult({
      routeResponse: routeResponse,
      error: undefined
    });
  }
  catch (e) {
    if (e.response && e.response.status === 404) {
      return new SearchRouteResult({
        routeResponse: undefined,
        error: undefined
      });
    }

    const isCancelled = axios.isCancel(e);
    if(!isCancelled) {
      console.error(e);
      if(e.response && e.response.data) {
        return new SearchRouteResult({
          routeResponse: undefined,
          error: new SearchRouteError({status: e.response.status, error: e.response.data.error, reason: e.response.data.reason, errorList: e.response.data.errorList})
        });
      }
    }

    // На остальные ошибки, включая CanceledError, возвращаем undefined и никак не влияем на отображение текущего маршрута
    return undefined;
  }
};

/** @param {SearchRouteParameters} searchParameters */
export const getVisualRoute = async searchParameters => {
  const request = {
    options: extractOptionsFromSearchParams(searchParameters),
    nodes: extractNodesFromSearchParams(searchParameters),
    excludeCities: searchParameters.excludedCities.map(city => city.id),
    excludeRegions: [],
    excludeCountries: searchParameters.excludedCountries.map(country => country.id),
    mapBounds: searchParameters.mapBounds,
    routeId: searchParameters.routeId
  }
  try {
    /** @type {RouteResponse} */
    const routeResponse = await api.distancer.getVisualRoute(request);
    return new SearchRouteResult({
      routeResponse: routeResponse,
      error: undefined
    });
  }
  catch (e) {
    if (e.response && e.response.status === 404) {
      return new SearchRouteResult({
        routeResponse: undefined,
        error: undefined
      });
    }

    const isCancelled = axios.isCancel(e);
    if(!isCancelled) {
      console.error(e);
      if(e.response && e.response.data) {
        return new SearchRouteResult({
          routeResponse: undefined,
          error: new SearchRouteError({status: e.response.status, error: e.response.data.error, reason: e.response.data.reason, errorList: e.response.data.errorList})
        });
      }
    }

    // На остальные ошибки, включая CanceledError, возвращаем undefined и никак не влияем на отображение текущего маршрута
    return undefined;
  }
};